export default {
    bloglist: {
        en: [
            {
                title: 'How to Download Instagram Photos Without Taking a Screenshot',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Screenshots crop quality. Learn how to save public photos and carousel slides with a post link on iPhone and Android.',
                name: 'en-how-to-download-instagram-photos-without-screenshot',
                url: '/how-to-download-instagram-photos-without-taking-a-screenshot/',
                date: '2026-09-28',
            },
            {
                title: 'How to Download Instagram Stories Before They Disappear',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Stories expire fast. Practical steps to copy a link, save photos or videos, and understand what you cannot access.',
                name: 'en-how-to-download-instagram-stories-before-disappear',
                url: '/how-to-download-instagram-stories-before-they-disappear/',
                date: '2026-09-28',
            },
            {
                title: 'How to Download Instagram Reels to Your Phone',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Copy a Reel link, download on Android or iPhone, and learn what to expect for audio and reuse.',
                name: 'en-how-to-download-instagram-reels-phone',
                url: '/how-to-download-instagram-reels-to-your-phone/',
                date: '2026-09-28',
            },
            {
                title: "Instagram Story vs Reels: What's the Difference and When Should You Use Each?",
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Compare Stories and Reels by lifespan, purpose, and format—and when saving each type makes sense.',
                name: 'en-instagram-story-vs-reels',
                url: '/instagram-story-vs-reels-whats-the-difference/',
                date: '2026-09-28',
            },
            {
                title: 'What Happened to Instagram IGTV? A Simple Guide to Old IGTV Videos',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'IGTV merged into Instagram Video in 2021. Why old links break and how to try legacy /tv/ URLs.',
                name: 'en-what-happened-to-instagram-igtv',
                url: '/what-happened-to-instagram-igtv/',
                date: '2026-09-28',
            },
            {
                title: 'Where Do Instagram Downloads Go on iPhone? Find Them Fast',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: "Can't find an Instagram photo or video you downloaded on iPhone? Learn where Safari and Chrome save downloads and how to move them to Photos.",
                name: 'en-where-do-instagram-downloads-go-on-iphone',
                url: '/where-do-instagram-downloads-go-on-iphone/',
                date: '2026-09-20',
            },
            {
                title: 'How to Download All Photos from an Instagram Carousel',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Want to save every photo from an Instagram carousel? Learn how to copy the right post link, download multiple images, and find them on your phone.',
                name: 'en-how-to-download-all-photos-from-instagram-carousel',
                url: '/how-to-download-all-photos-from-instagram-carousel/',
                date: '2026-09-20',
            },
            {
                title: 'Why Is My Instagram Download Blurry? Causes & Fixes',
                poster: require('@/assets/snapinsta-blog.webp'),
                desc: 'Is your Instagram photo or video blurry after downloading? Learn why it happens, how to check file quality, and how to get the best available version.',
                name: 'en-why-is-my-instagram-download-blurry',
                url: '/why-is-my-instagram-download-blurry/',
                date: '2026-09-20',
            },
            {
                title: 'Is It Safe to Use SnapInsta?',
                poster: require('@/assets/blog-1.webp'),
                desc: 'SnapInsta enables quick Instagram downloads without login, offering convenience, but users should consider privacy, malware, and copyright risks before using it.',
                name: 'en-is-it-safe-to-use-snapinsta',
                url: '/is-it-safe-to-use-snapinsta/',
                date: '2026-02-03',
            },
        ],
    },
};
